<template>
  <div v-if="searchActive && role" class="global-nav-search">
    <VueSelect
      ref="globalSearch"
      :options="options"
      :filter="dropdownFilter"
      placeholder="Go to"
      transition="zoomIn"
      label="name"
      @search:blur="searchActive = false"
      @input="handleInput"
    >
      <template #option="{ name, href }">
        {{ name }}
        <br />
        <cite>Path: {{ href }}</cite>
      </template>
    </VueSelect>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import Fuse from "fuse.js"
import router from "@/router/index"

export default {
  components: { VueSelect },
  data() {
    return {
      searchActive: false,
      options: [],
      role: localStorage.role,
    }
  },
  created() {
    const { routes } = router.options
    const staticRoutes = []
    routes.forEach(item => {
      /* ignore all the routes with dynamic param */
      if (!item.path.includes("/:")) {
        staticRoutes.push({ name: item.meta.title, href: item.path })
      }
    })
    this.options = staticRoutes
  },
  mounted() {
    document.addEventListener("keyup", evt => {
      const blackListedTags = ["textarea", "input"]
      const nodeName = evt.target.nodeName.toLowerCase()
      /* bring menu on pressing slash(/) if any input/textarea isn't focused */
      if (
        this.role &&
        !evt.target.isContentEditable &&
        evt.which === 191 &&
        !blackListedTags.includes(nodeName)
      ) {
        this.searchActive = true
        this.$nextTick(() => {
          this.$refs.globalSearch.$refs.search.focus()
        })
      }
    })
  },
  methods: {
    dropdownFilter(options, search) {
      const fuse = new Fuse(options, {
        keys: ["name", "href"],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
    handleInput(data) {
      this.$router.push({ path: data.href })
    },
  },
}
</script>

<style>
.global-nav-search {
  position: absolute;
  z-index: 10;
  top: 20%;
  left: calc(50% - 15rem);
  width: 100%;
  max-width: 30rem;
  margin: auto;
  border-radius: 5px 5px 0 0;
  background: white;
  animation: zoomIn 0.1s cubic-bezier(0, 0.74, 0, 0.98);
}

.global-nav-search .dropdown-menu {
  border: none;
  box-shadow: 0px 0px 0px 0px white, 0px 15px 15px #444444,
    0 2px 0px 0px #2e2e2e, 0 0px 0px 0px grey;
}
.global-nav-search .dropdown,
.global-nav-search .vs__dropdown-menu {
  border: none;
  border-radius: 5px 5px 0 0;
  background: #ffffff;
  box-shadow: 0 2px 15px 0px #2e2e2e;
}

.global-nav-search .v-select input[type="search"],
.global-nav-search .v-select input[type="search"]:focus {
  padding: 0.5rem 1rem;
}

.global-nav-search .dropdown-menu li a {
  padding: 0.7rem 1rem;
}

@keyframes zoomIn {
  0% {
    transform: scale(0.8) translateY(8rem);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}
</style>
